module.exports = __webpack_public_path__ + "img/140ne.a3c1d9a9.svg";